let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let Notes = require("./Notes");
let Bureau = require("./Bureau");
let SalesRep = require("./SalesRep");
let esUtils = require("ES/utils/esUtils");
let Stagetimes = require("./Stagetimes");
let EventActions = require("./event_actions");
let BasicDetails = require("./BasicDetails");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let ParentChildControls = require("./ParentChildControls");
let isEventAccountingLockedForMe = require("../../../../../utils/isEventAccountingLockedForMe");
let _ = require("ES/lib/lodash");
module.exports = dd.createClass({
  getInitialState() {
    return { show_actions: false };
  },
  __toggleShowActions: esUtils.wrapPreventDefault(function () {
    this.setState({ show_actions: !this.state.show_actions });
  }),
  __reloadEvent: esUtils.wrapPreventDefault(function () {
    if (this.props.event && this.props.event.eid > 0) {
      radio("reload_Event").broadcast(this.props.event.eid);
    }
  }),
  render() {
    let { event, Displaylists } = this.props;
    let is_read_or_travel = AuthedUserSession.doIHaveAccess.read_or_travel.all(
      event.sids
    );
    let is_limited_speaker =
      AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);
    let preferences = _.get(Displaylists, "user.myevents_preferences", {});
    let show_parentchild =
      !event.is_mp_event &&
      (_.get(preferences, "show_parent_child_ui", false) ||
        (AuthedUserSession.is_st_family &&
          !AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids)));
    let is_cs = AuthedUserSession.is_cs;

    return dd.div(
      { className: "EventDetails" },
      dd.h2(
        null,
        "Event Details",
        dd.span(
          { className: "pull-right" },
          is_read_or_travel || is_limited_speaker
            ? null
            : dd.a(
                {
                  href:
                    "/reports/loader.php?report=eventdetails.php&eid=" +
                    event.eid +
                    "&output_format=html",
                  target: "_blank",
                  style: {
                    fontWeight: "normal",
                    fontSize: "14px",
                    marginRight: "5px",
                  },
                },
                dd.i({ className: "fa fa-print" }),
                " Print"
              ),
          show_parentchild
            ? ParentChildControls({ event, Displaylists })
            : null,
          " ",
          is_read_or_travel || is_limited_speaker
            ? null
            : dd.button(
                {
                  className:
                    "btn btn-sm btn-default" +
                    (this.state.show_actions ? " active" : ""),
                  onClick: this.__toggleShowActions,
                },
                "Event Actions"
              ),
          " ",
          dd.button(
            {
              className: "btn btn-sm btn-default",
              onClick: this.__reloadEvent,
            },
            dd.i({ className: "fa fa-refresh" })
          )
        )
      ),
      !this.state.show_actions ? null : EventActions({ event, Displaylists }),
      BasicDetails({
        event,
        Displaylists,
        read_only: is_read_or_travel || is_limited_speaker || event.is_mp_event,
      }),
      Stagetimes({
        event,
        Displaylists,
        read_only:
          is_read_or_travel ||
          is_limited_speaker ||
          event.is_mp_event ||
          isEventAccountingLockedForMe(event) ||
          (AuthedUserSession.privatelabel_code === "cs"
            ? !AuthedUserSession.doIHaveAccess.full.any(event.sids)
            : false),
      }),
      AuthedUserSession.is_st_family
        ? SalesRep({
            form_section_name: "Internal Team",
            event,
            Displaylists,
            read_only:
              is_read_or_travel || is_limited_speaker || event.is_mp_event,
            is_limited_speaker: is_limited_speaker,
          })
        : Bureau({
            form_section_name: "Bureau",
            event,
            Displaylists,
            read_only:
              is_read_or_travel || is_limited_speaker || event.is_mp_event,
            is_limited_speaker: is_limited_speaker,
          }),
      !is_limited_speaker || is_cs
        ? Notes({
            event,
            Displaylists,
            read_only: is_read_or_travel,
          })
        : null
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/index.js